import { render, staticRenderFns } from "./COGM.vue?vue&type=template&id=82c0aab2"
import script from "./COGM.vue?vue&type=script&lang=js"
export * from "./COGM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports